import React from "react";
import "./section.scss";

function BackgroundImg() {
  return <div className="section__background"></div>;
}

export default BackgroundImg;
